import { render, staticRenderFns } from "./selectXz.vue?vue&type=template&id=7d0c33c0&scoped=true&"
import script from "./selectXz.vue?vue&type=script&lang=js&"
export * from "./selectXz.vue?vue&type=script&lang=js&"
import style0 from "./selectXz.vue?vue&type=style&index=0&id=7d0c33c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0c33c0",
  null
  
)

export default component.exports